/**
 * Helpers de couleur du portail.
 *
 * Remplace l'idiome `${couleur}55` — une paire hexadecimale d'alpha collee a la
 * fin d'un hex a 6 chiffres. Ce bricolage imposait que la couleur soit un hex
 * litteral, ce qui interdisait d'utiliser les jetons de la charte
 * (`rgb(var(--c-teal))`) dans les tables de donnees (DESIGN-GUIDE §0).
 *
 * `avecAlpha` accepte les deux formes et rend une couleur CSS valide :
 *   avecAlpha('rgb(var(--c-teal))', 0.33)              -> 'rgb(20 184 166 / 0.33)'
 *   avecAlpha('rgb(var(--c-teal))', 0.33)   -> 'rgb(var(--c-teal) / 0.33)'
 */

/** Convertit '#rgb' ou '#rrggbb' en canaux « r g b ». */
const canauxDepuisHex = (hex) => {
  let h = hex.slice(1)
  if (h.length === 3) h = h.split('').map((c) => c + c).join('')
  const n = parseInt(h, 16)
  return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`
}

/**
 * Applique une opacite a une couleur, qu'elle soit un hex litteral ou un jeton
 * `rgb(var(--c-x))`.
 * @param {string} couleur hex ('rgb(var(--c-teal))') ou jeton ('rgb(var(--c-teal))')
 * @param {number} alpha opacite entre 0 et 1
 * @returns {string} couleur CSS avec alpha
 */
export const avecAlpha = (couleur, alpha) => {
  if (typeof couleur !== 'string') return couleur
  const c = couleur.trim()
  if (c.startsWith('#')) return `rgb(${canauxDepuisHex(c)} / ${alpha})`
  // Jeton `rgb(var(--c-x))` : on insere l'alpha avant la parenthese fermante.
  const jeton = c.match(/^rgb\(\s*(var\(--[\w-]+\))\s*\)$/)
  if (jeton) return `rgb(${jeton[1]} / ${alpha})`
  // Deja une couleur avec alpha (rgba(...), rgb(... / ...)) : on la rend telle
  // quelle plutot que d'en fabriquer une invalide.
  return c
}
